<template>
	<div class="form-group">
		<!-- <label>{{ questionKey + 1}}. Frage</label>
		<b-button v-on:dblclick.native="removeMe(questionKey)" :variant="'link'"  :size="'sm'" class="text-muted pull-right">entfernen</b-button> -->
		<b-form-input :textarea="true" v-model="question.content"></b-form-input>

		<b-input-group left="Antwort" class="mt-2">
			<b-form-input v-model="question.answer"></b-form-input>
		</b-input-group>

		<div v-for="(alternative, altKey) of question.alternatives" :key="altKey" class="mt-2 ml-5">
			<b-button @click="removeAlternative(questionKey, altKey)" :size="'sm'" :variant="'link'" class="pull-right"><i class="fa fa-times text-muted"></i></b-button>
			<b-input-group :left="( altKey + 1 ) + '. Alternative'" :size="'sm'" class="mb-1">
				<b-form-input v-model="alternative.answer"></b-form-input>
			</b-input-group>

			<b-form-input :textarea="true" v-model="alternative.message" placeholder="Message.."></b-form-input>

		</div>

		<b-button @click="addAlternative()" :variant="'link'" :size="'sm'" class="pull-right mt-2"><i class="fa fa-plus fa-fw"></i> Alternative</b-button>
	</div>
</template>

<script>
	export default {
		name: 'question-one-edit',
		data () {
			return {}
		},
		props: {
			question: {
				type: Object,
				required: true
			},
			questionKey: {
				type: Number,
				required: true
			}
		},
		updated(){
			// console.log('Question.Edit.vue was updated.', this.question)
		},
		mounted() {
			// console.log('Question.Edit.vue was mounted.', this.question)
		},
		methods:{
			addAlternative(){
				// console.log('addAlternative', questionKey, 'Active Quiz: ', this.activeQuiz)
				console.log('addAlternative', this.question)
				let question = this.question

				let newAlternative = {answer: '', message: ''}

				// question.alternatives
				// ? question.alternatives.push(newAlternative)
				// : question.alternatives = [newAlternative]

				
				question.alternatives
				? question.alternatives.push(newAlternative)
				: this.$set(this.question, 'alternatives', [newAlternative])



				// if(question.alternatives){
				// 	question.alternatives.push(newAlternative)
				// }else{
				// 	// question.alternatives = [newAlternative]
				// 	this.$set(this.question, 'alternatives', [newAlternative])
				// }

				// this.$forceUpdate()
			},

			removeAlternative(questionKey, alternativeKey){
				this.question.alternatives.splice(alternativeKey, 1)
				// this.$forceUpdate()
			},

			// removeMe(){
			// 	console.log('removeMe()')
			// 	this.$emit('remove', this.questionKey)
			// }
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// One.Edit.vue?a26f9368